import { createGlobalStyle } from "styled-components";
import TheBoldFont from "./assets/fonts/theboldfont.ttf";
import AcrylicHandThick from "./assets/fonts/AcrylicHandThick-Regular.ttf";
import RegisterTypeArrow from "./assets/img/registerTypeArrow.svg";

const GlobalStyle = createGlobalStyle`
        
        @font-face{
            font-family: 'the bold font';
            src: url(${TheBoldFont}) format('truetype');
        };
        
        @font-face{
            font-family: 'Acrylic Hand Thick';
            src: url(${AcrylicHandThick}) format('truetype');
        };

        .register-type::before{
            background: url(${RegisterTypeArrow})
        };
    `;
export default GlobalStyle;
